export class OpenEmailListDialogAction {
   public static readonly type = '[EmailListDialog] Open Email List';
}

export class CloseEmailListDialogAction {
   public static readonly type = '[EmailListDialog] Close Email List';
}

export class ToggleEmailListDialog {
   public static readonly type = '[EmailListDialog] Toggle Email List';
}
